function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import { AppContext } from 'context';
import copyTextToClipboardFallback from 'helpers/copyTextToClipboardFallback';
import Button from 'components/Form/Button';
import CopyButton from 'svg/copy.svg';
import Account from 'modules/Account';
import messages from '../../../../messages';
import styles from './EnrollCodeBtn.pcss';
var _React_Component;
class EnrollCodeBtn extends (_React_Component = React.Component) {
    copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            copyTextToClipboardFallback(text);
            return;
        }
        navigator.clipboard.writeText(text);
    }
    render() {
        const enrollCode = get(this.props.activeClinicMembership, 'enrollCode');
        if (!enrollCode) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Button, {
            id: "copyClinicCodeBtn",
            onClick: ()=>this.copyTextToClipboard(enrollCode),
            styleModifier: this.props.styleModifier,
            className: cn(styles.root, this.props.className),
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.label,
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.topBar.buttons.enroll)),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.enrollCode,
                        "data-testid": "enroll-code",
                        children: [
                            enrollCode,
                            /*#__PURE__*/ _jsx(CopyButton, {})
                        ]
                    })
                ]
            })
        });
    }
}
_define_property(EnrollCodeBtn, "contextType", AppContext);
_define_property(EnrollCodeBtn, "propTypes", {
    // Explicit props
    styleModifier: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership
});
_define_property(EnrollCodeBtn, "defaultProps", {
    styleModifier: 'transparent-primary',
    className: 'btn--block btn--filled'
});
const mapStateToProps = (state)=>({
        activeClinicMembership: Account.selectors.activeClinicMembership(state)
    });
const ConnectedEnrollCodeBtn = connect(mapStateToProps)(EnrollCodeBtn);
export default withStyles(styles)(ConnectedEnrollCodeBtn);
